import React from 'react';
import { ContentNodeConfigurationPropType } from '../../../../../../../../services/proptypes';
var defaultProps = {};
function Content(_ref) {
  var element = _ref.element;
  var content = element.content;
  return /*#__PURE__*/React.createElement("span", null, content);
}
Content.defaultProps = defaultProps;
export default Content;